import { render, staticRenderFns } from "./NewAdvance.vue?vue&type=template&id=71f732fc&scoped=true"
import script from "./NewAdvance.vue?vue&type=script&lang=js"
export * from "./NewAdvance.vue?vue&type=script&lang=js"
import style0 from "./NewAdvance.vue?vue&type=style&index=0&id=71f732fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f732fc",
  null
  
)

export default component.exports